<template>
    <div class="container-fluid">
        <div class="h2">
            {{ title }}
        </div>
        <div class="row mb-2 mb-md-4">
            <template v-for="(zoneMobilesItem, index) in zoneMobiles.zoneMobilesItem">
                <div :key="index" class="col-12 col-md-6" :class="(index > 0) ? 'mt-1 mt-md-0' : ''">
                    <ob1-cards class="d-flex flex-column h-100 border-0" :is-multiple="true" :with-composite-link="true">
                        <img :src="zoneMobilesItem.image.src" class="w-100" :alt="zoneMobilesItem.image.alt">
                        <div class="px-1 px-md-2 d-flex flex-column flex-grow-1 bg-dark">
                            <h3 class="text-primary mt-1 pb-0 mb-0">
                                {{ zoneMobilesItem.title }}
                            </h3>
                            <div class="lead text-white mb-1">
                                {{
                                    zoneMobilesItem.text
                                }}
                            </div>
                            <ob1-boutons
                                class="mb-2 mt-auto align-self-center align-self-md-start"
                                :is-secondary="true"
                                :is-inverse="true"
                                :is-button="false"
                                :label="zoneMobilesItem.labelButton"
                                :href="zoneMobilesItem.urlButton"
                                :data-oevent-category="zoneMobilesItem.tms.tagZone"
                                :data-oevent-action="zoneMobilesItem.tms.tagName"
                                :data-oevent-label="zoneMobilesItem.urlButton"
                            />
                        </div>
                    </ob1-cards>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        zoneMobiles: {
            type: Object,
            required: true
        },
    },
    methods: {

    },
}
</script>

<style scoped lang="scss">

</style>
